export enum ExportTypes {
  'Actions' = 'Actions',
  'Objectives' = 'Objectives',
  'Scoreboard' = 'Scoreboard',
}

export enum ExportMethod {
  'Email' = 'Email',
  'Print' = 'Print',
}

export enum ExportFormat {
  'PDF' = 'PDF',
  'CSV' = 'CSV',
}

export enum ExportTimeRangeOptions {
  'LastSevenDays' = 'LastSevenDays',
  'LastThirtyDays' = 'LastThirtyDays',
  'LastYear' = 'LastYear',
  'All' = 'All',
  'Custom' = 'Custom',
}

export enum ScoreBoardExportSections {
  'Daily' = 'Daily',
  'Weekly' = 'Weekly',
  'Monthly' = 'Monthly',
  'Quarterly' = 'Quarterly',
  'Annually' = 'Annually',
}
